Object.defineProperty(exports, "__esModule", { value: true });
exports.pseudo = void 0;
var pseudo_1 = require("./lib/pseudo");
Object.defineProperty(exports, "pseudo", { enumerable: true, get: function () { return pseudo_1.pseudo; } });
